// import React from "react";
// import "../assets/styles/Card.css";

// const Card = ({ text, number, icon, onClick }) => {
//   return (
//     <div
//       className="cardStyle"
//       onClick={onClick}               // make whole card clickable
//       style={{ cursor: onClick ? "pointer" : "default" }}
//     >
//       <div className="cardStyle2">
//         <span className="cardText" style={{ fontSize: "22px" }}>
//           <span style={{ paddingLeft: "15px" }}>{text} </span>
//         </span>
//       </div>
//       <div className="textIcon">
//         <div className="cardText">{icon}</div>
//         <div className="cardText">
//           <span style={{ paddingLeft: "15px" }}>{number}</span>
//         </div>
//       </div>
//     </div>
//   );
// };



// export default Card;

import React from "react";
import { Tooltip } from "@mui/material";
import "../assets/styles/Card.css";

const Card = ({ text, number, icon, onClick }) => {
  return (
    <div
      className="cardStyle"
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default", display: "flex", flexDirection: "column" }}
    >
      {/* Top text row */}
      <div className="cardStyle2">
        <Tooltip title={text} arrow>
          <span
            className="cardText"
            style={{ 
              fontSize: "18px", 
              display: "block", 
              textAlign: "left", 
              paddingLeft: "15px",
              paddingRight: "10px",
              paddingTop: "5px",
              paddingBottom: "5px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
          >
            {text}
          </span>
        </Tooltip>
      </div>

      {/* Bottom row: number left, icon right */}
      <div
        className="textIcon"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flex: 1,
          paddingBottom: "10px"
        }}
      >
        <div
          className="cardText"
          style={{ textAlign: "left", paddingLeft: "15px", fontSize: "32px" }}
        >
          {number}
        </div>
        <div
          className="cardText"
          style={{ textAlign: "right", paddingRight: "15px" }}
        >
          {React.cloneElement(icon, { sx: { ...icon.props.sx, fontSize: "40px" } })}
        </div>
      </div>
    </div >
  );
};

export default Card;
